Shopify.queryParams = {};
if (location.search.length) {
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
    i < aCouples.length;
    i++
  ) {
    aKeyValue = aCouples[i].split("=");
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
        decodeURIComponent(aKeyValue[1]);
    }
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
};

var stock = getUrlParameter("stock");

if (stock !== "in-stock") {
  $(".light-switch-wrapper").on("click", function () {
    $(this).find("div").toggleClass("active");
    $(this).toggleClass("active");
  });
}
if (stock === "in-stock") {
  $(".light-switch .switch").addClass("active");
  $(".light-switch-wrapper").addClass("active");
  $(".link-overlay").on("click", function () {
    $(".light-switch .switch").toggleClass("active");
    $(".light-switch-wrapper").removeClass("active");
  });
}

jQuery(document).ready(function () {
  jQuery(".js-drawer-open-left").click(function () {
    var $bodyWrap = jQuery("body");
    var $pageContainer = jQuery("#PageContainer");

    if (!$bodyWrap.hasClass("js-drawer-open")) {
      $pageContainer.addClass("scroll-lock");
    } else {
      $pageContainer.removeClass("scroll-lock");
    }
  });

  jQuery("#homepage").owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplaySpeed: 8000,
    dots: true,
    animateOut: "fadeOut",
    onInitialized: function (event) {
      jQuery(event.target)
        .find("video")
        .each(function () {
          // Show loading animation.
          jQuery(this).get(0).play();
        });
    },
  });

  jQuery("#bespoke-slider").owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    dots: true,
    animateOut: "fadeOut",
  });

  jQuery("#engraving-slider").owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    dots: true,
    animateOut: "fadeOut",
  });

  jQuery("#collection-slider, #cart-products").owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    nav: true,
    margin: 50,
    navText: [
      '<img src="https://cdn.shopify.com/s/files/1/2213/3555/files/orange-arrow-left.png?18388554923507523235"/>',
      '<img src="https://cdn.shopify.com/s/files/1/2213/3555/files/orange-arrow-right.png?18388554923507523235"/>',
    ],
    responsive: {
      320: {
        items: 1,
      },
      667: {
        items: 2,
      },
      768: {
        items: 2,
      },
      1366: {
        items: 3,
      },
    },
  });

  jQuery(".article-products").owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    nav: true,
    margin: 60,
    navText: [
      '<img src="https://cdn.shopify.com/s/files/1/2213/3555/files/arrow-left-blue.svg?6255291957364223569"/>',
      '<img src="https://cdn.shopify.com/s/files/1/2213/3555/files/arrow-right-blue_66e4ba2b-10e2-4657-a5af-f878c9260319.svg?6166580795719354020"/>',
    ],
    responsive: {
      320: {
        items: 1,
      },
      414: {
        items: 1,
      },
      667: {
        items: 2,
      },
      736: {
        items: 2,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  });

  jQuery(".article-products-second").owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    nav: true,
    margin: 60,
    navText: [
      '<img src="https://cdn.shopify.com/s/files/1/2213/3555/files/arrow-left-blue.svg?6255291957364223569"/>',
      '<img src="https://cdn.shopify.com/s/files/1/2213/3555/files/arrow-right-blue_66e4ba2b-10e2-4657-a5af-f878c9260319.svg?6166580795719354020"/>',
    ],
    responsive: {
      320: {
        items: 1,
      },
      414: {
        items: 1,
      },
      667: {
        items: 2,
      },
      736: {
        items: 2,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  });

  //Scroll reveal
  window.sr = ScrollReveal();
  sr.reveal(".fade-in", {
    duration: 800,
    origin: "top",
    delay: 500,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    scale: 1,
  });

  jQuery("#faq-accordion .panel-title").click(function () {
    var currentPanel = jQuery(this).parent().find(".panel-content");

    if (!currentPanel.hasClass("open")) {
      currentPanel.slideDown().addClass("open");
      currentPanel.parent().find(".panel-title").addClass("open");
      jQuery(this)
        .find("img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2213/3555/files/accordion-minus-white.svg?18331193154602332594"
        );
    } else {
      currentPanel.slideUp().removeClass("open");
      currentPanel.parent().find(".panel-title").removeClass("open");
      jQuery(this)
        .find("img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2213/3555/files/accordion-plus.svg?15415441695658137485"
        );
    }
  });

  jQuery("#pearl-accordion .panel-title").click(function () {
    var currentPanel = jQuery(this).parent().find(".panel-content");
    var forAttr = jQuery(this).attr("data-for");

    if (currentPanel.attr("id") == forAttr && !currentPanel.hasClass("open")) {
      currentPanel.slideDown().addClass("open");
      jQuery(this).slideDown().addClass("open");
      jQuery(this)
        .find("img.plus-img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2213/3555/files/accordion-minus-new.svg"
        );
    } else {
      jQuery(currentPanel).slideUp();
      jQuery(this).removeClass("open");
      setTimeout(function () {
        jQuery(currentPanel).removeClass("open");
      }, 400);
      jQuery(this)
        .find("img.plus-img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2213/3555/files/accordion-plus.svg?15415441695658137485"
        );
    }
  });

  jQuery("#stone-accordion .panel-title").click(function () {
    var currentPanel = jQuery(this).parent().find(".panel-content");
    var forAttr = jQuery(this).attr("data-for");

    if (currentPanel.attr("id") == forAttr && !currentPanel.hasClass("open")) {
      currentPanel.slideDown().addClass("open");
      jQuery(this).slideDown().addClass("open");
      jQuery(this)
        .find("img.plus-img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2213/3555/files/accordion-minus-new.svg?v=1614163219"
        );
    } else {
      jQuery(currentPanel).slideUp();
      jQuery(this).removeClass("open");
      setTimeout(function () {
        jQuery(currentPanel).removeClass("open");
      }, 400);
      jQuery(this)
        .find("img.plus-img")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2213/3555/files/accordion-plus.svg?15415441695658137485"
        );
    }
  });
  jQuery(
    "#accordian_section .pro_desk_hide .panel-title, #engrave-accordion .panel-title"
  ).click(function () {
    var $root = jQuery(this).closest(".pro_desk_hide, #engrave-accordion");
    $root.find(".panel-title").removeClass("open");

    var $target = jQuery(this).next(".panel-content");
    $root.find(".panel-content").not($target).slideUp(300).removeClass("open");

    if ($target.is(":visible")) {
      $target.slideUp("slow").removeClass("open");
      jQuery(this).removeClass("open");
    } else {
      $target.slideDown("slow").addClass("open");
      jQuery(this).addClass("open");
    }
  });

  //Here is the code to close the size guide popup
  jQuery("#size-guide-popup .modal img.close,svg.close").click(function () {
    jQuery(this)
      .parents("#size-guide-popup")
      .css({ opacity: 0, visibility: "hidden" });
    jQuery("body").removeClass("lock");
  });
  jQuery("#ge-calculate-popup svg.close").click(function () {
    jQuery(this)
      .parents("#ge-calculate-popup")
      .css({ opacity: 0, visibility: "hidden" });
    jQuery(this).parents("#ge-calculate-popup").removeClass("popupfadeIn");
    jQuery("body").removeClass("lock");
  });

  jQuery("#book-con-popup svg.close").click(function () {
    jQuery(this)
      .parents("#book-con-popup")
      .css({ opacity: 0, visibility: "hidden" });
    jQuery(this).parents("#book-con-popup").removeClass("popupfadeIn");
    jQuery("body").removeClass("lock");
  });
  jQuery("#expandFootprint svg.close").click(function () {
    jQuery(this)
      .parents("#expandFootprint")
      .css({ opacity: 0, visibility: "hidden" });
    jQuery(this).parents("#expandFootprint").removeClass("popupfadeIn");
    jQuery("body").removeClass("lock");
  });
  jQuery("#firstCertificate svg.close").click(function () {
    jQuery(this)
      .parents("#firstCertificate")
      .css({ opacity: 0, visibility: "hidden" });
    jQuery(this).parents("#firstCertificate").removeClass("popupfadeIn");
    jQuery("body").removeClass("lock");
  });
  jQuery("#secondCertificate svg.close").click(function () {
    jQuery(this)
      .parents("#secondCertificate")
      .css({ opacity: 0, visibility: "hidden" });
    jQuery(this).parents("#secondCertificate").removeClass("popupfadeIn");
    jQuery("body").removeClass("lock");
  });
  jQuery("#mobileCertificate svg.close").click(function () {
    jQuery(this)
      .parents("#mobileCertificate")
      .css({ opacity: 0, visibility: "hidden" });
    jQuery(this).parents("#mobileCertificate").removeClass("popupfadeIn");
    jQuery("body").removeClass("lock");
  });
  jQuery("#cookie-bar .close").click(function () {
    Cookies.set("cookies", 1, { expires: 7 });
    jQuery(this).parent().fadeOut();
  });

  var cookie = Cookies.get("cookies");

  if (cookie != 1 || !cookie) {
    jQuery("#cookie-bar").fadeIn();
  }

  jQuery(
    "#customise-accordion .panel-title, .bespoke-accordion .panel-title"
  ).click(function () {
    var $currentPanel = jQuery(this).parent().find(".panel-content");
    var $currentPanelImg = jQuery(this).find("img");

    if (!$currentPanel.hasClass("open")) {
      $currentPanel.slideDown().addClass("open");
      $currentPanelImg.attr(
        "src",
        "https://cdn.shopify.com/s/files/1/2213/3555/files/accordion-minus-new_325332b6-29a5-4a12-bc07-1f935156ed3d.svg?v=1663561900"
      );
      $currentPanelImg.addClass("minus");
    } else {
      $currentPanel.slideUp();

      setTimeout(function () {
        $currentPanel.removeClass("open");
      }, 400);

      $currentPanelImg.attr(
        "src",
        "https://cdn.shopify.com/s/files/1/2213/3555/files/accordion-plus.svg?v=1613534496"
      );
      $currentPanelImg.removeClass("minus");
    }
  });

  jQuery(".mobile-nav__search").click(function (event) {
    /* Do not preventDefault on taps inside the open drawer — that blocks input focus / typing on mobile. */
    if (jQuery(event.target).closest(".search-drawer").length) {
      return;
    }
    event.preventDefault();
    var $form = jQuery(".search-drawer:not(.desk-search-drawer)");
    $form.css({
      opacity: 1,
      visibility: "visible",
      display: "block",
      transform: "translate(0px,0px)",
      transition: "all 0.5s",
    });
    $form.find("input.input-group-field, input[type='search']").first().focus();
  });

  /* Desk drawer also has .search-drawer — do not use stopImmediatePropagation here or the desk-only handler never runs. */
  jQuery(document).on("click", ".search-drawer .close_btn", function (event) {
    event.preventDefault();
    event.stopPropagation();
    var $drawer = jQuery(this).closest(".search-drawer");
    if ($drawer.hasClass("desk-search-drawer")) {
      $drawer.hide();
    } else {
      jQuery(".search-drawer:not(.desk-search-drawer)").css({
        opacity: 0,
        visibility: "hidden",
        transform: "translateY(-130%)",
        transition: "all 1s",
      });
    }
  });

  jQuery(".toggles li.site-header__cart-toggle .icon").click(function () {
    toggleCartPopout(jQuery(this).parent());
  });

  // jQuery("#size-guide-toggle").click(function (event) {
  //   event.preventDefault();
  //   jQuery("#size-guide-popup").css({ opacity: 1, visibility: "visible" });
  //   jQuery("body").addClass("lock");
  // });

  jQuery(".ge-part1-inner #ge-calc-toggle").click(function (event) {
    event.preventDefault();
    jQuery("#ge-calculate-popup").css({ opacity: 1, visibility: "visible" });
    jQuery("#ge-calculate-popup").addClass("popupfadeIn");
    jQuery("body").addClass("lock");
  });

  jQuery(".ge-part2-inner #ge-calc-toggle").click(function (event) {
    event.preventDefault();
    jQuery("#ge-calculate-popup").css({ opacity: 1, visibility: "visible" });
    jQuery("#ge-calculate-popup").addClass("popupfadeIn");
    jQuery("body").addClass("lock");
  });

  jQuery(".book-consultancy-toggle").click(function (event) {
    event.preventDefault();
    jQuery("#book-con-popup").css({ opacity: 1, visibility: "visible" });
    jQuery("#book-con-popup").addClass("popupfadeIn");
    jQuery("body").addClass("lock");
  });
  jQuery("#footprint").click(function (event) {
    event.preventDefault();
    jQuery("#expandFootprint").css({ opacity: 1, visibility: "visible" });
    jQuery("#expandFootprint").addClass("popupfadeIn");
    jQuery("body").addClass("lock");
  });
  jQuery("#certificate-1").click(function (event) {
    event.preventDefault();
    jQuery("#firstCertificate").css({ opacity: 1, visibility: "visible" });
    jQuery("#firstCertificate").addClass("popupfadeIn");
    jQuery("body").addClass("lock");
  });
  jQuery("#certificate-2").click(function (event) {
    event.preventDefault();
    jQuery("#secondCertificate").css({ opacity: 1, visibility: "visible" });
    jQuery("#secondCertificate").addClass("popupfadeIn");
    jQuery("body").addClass("lock");
  });
  jQuery("#mo-certificate").click(function (event) {
    event.preventDefault();
    jQuery("#mobileCertificate").css({ opacity: 1, visibility: "visible" });
    jQuery("#mobileCertificate").addClass("popupfadeIn");
    jQuery("body").addClass("lock");
  });
  productImageChoice();

  jQuery(".gif .text").lettering();

  setTimeout(function () {
    jQuery(".gif").css("opacity", 1);
  }, 500);

  jQuery(".section-header .filter-toggles a").click(function (event) {
    var $this = jQuery(this);

    if ($this.attr("id") != "clear") {
      event.preventDefault();
      var $activeLink = jQuery(".section-header a.open");
      var $openFilters = jQuery(".filter-sort.open");
      var target = $this.attr("data-for");
      var $targetFilters = jQuery("#" + target);

      if ($openFilters.attr("id") == target) {
        $this.toggleClass("open");
        $this.find("i").toggleClass("fa-angle-down fa-angle-up");
        $openFilters.slideUp().removeClass("open");
        $(".closeFiletrMobile").hide();
        $(".closeFiletrSortMobile").hide();
      } else {
        $activeLink.removeClass("open");
        $(".closeFiletrMobile").hide();
        $(".closeFiletrSortMobile").hide();
        $activeLink.find("i").toggleClass("fa-angle-down fa-angle-up");
        $this.addClass("open");
        $(".closeFiletrMobile").show();
        $(".closeFiletrSortMobile").show();
        $this.find("i").toggleClass("fa-angle-down fa-angle-up");

        $openFilters.slideUp().removeClass("open");
        $(".closeFiletrMobile").show();
        $(".closeFiletrSortMobile").show();
        $targetFilters.slideDown().addClass("open");
        $(".closeFiletrMobile").show();
        $(".closeFiletrSortMobile").show();
      }
    }
  });

  //Sortby on collection page
  jQuery("#sort-by li a").click(function () {
    var val = jQuery(this).attr("data-val");
    jQuery("#SortBy").val(val).change();
  });

  //Metal option on the product page
  if (!jQuery(".product-single").hasClass("custom-product")) {
    jQuery(".selector-wrapper").each(function () {
      var $this = jQuery(this);
      var heading = $this.find("label").text();
      var $options = $this.find("select option");

      if (heading == "Metal") {
        $this.hide();
        var customMetalSelectId = heading.toLowerCase() + "-choice";
        jQuery(".product-variants").prepend(
          "<h5 class='custom-variant-title'>Metal</h5><ul id='" +
          customMetalSelectId +
          "' class='" +
          customMetalSelectId +
          "' data-target='" +
          $this.find("select").attr("id") +
          "'></ul>"
        );

        $options.each(function () {
          var $option = jQuery(this);
          var classVal = getMetalClass(
            $option.text().toLowerCase().replace("& ", "").split(" ").join("-")
          );
          jQuery("#" + customMetalSelectId).append(
            "<li class='" +
            classVal +
            "'><a href='#' data-desc-target='" +
            $option
              .text()
              .toLowerCase()
              .replace("& ", "")
              .split(" ")
              .join("-") +
            "' data-val='" +
            $option.text() +
            "' title='" +
            $option.text() +
            "'></a></li>"
          );
        });

        $("#" + customMetalSelectId + " a").click(function (event) {
          event.preventDefault();
          var $this = $(this);
          var selectedVal = $this.attr("data-val");
          var targetSelectId = $this.parents("ul").attr("data-target");
          var $select = $("#" + targetSelectId);

          $("#" + customMetalSelectId + " a.current").removeClass("current");
          $(".metal-descriptions .description.current").removeClass("current");
          var attargrt = $(
            ".metal-descriptions .description." + $this.attr("data-desc-target")
          ).addClass("current");
          var attargrtnew = $(
            ".metal-descriptions .description." + $this.attr("data-desc-target")
          );
          $this.addClass("current");
          $select.val(selectedVal).change();
        });
      }
    });
  } else {
    jQuery(".selector-wrapper").each(function () {
      var $this = jQuery(this);
      var $form = jQuery(".AddToCartForm");
      var $customElementWrapper = $form.find(".custom-chooser");
      var heading = $this.find("label").text();
      var $options = $this.find("select option");

      switch (heading) {
        case "Cufflink Style":
          $this.hide();
          var customCufflinkStyleSelectId =
            heading.toLowerCase().split(" ").join("-") + "-choice";
          $customElementWrapper.append(
            "<h5 class='custom-variant-title text-left'>Cufflink Style</h5><ul id='" +
            customCufflinkStyleSelectId +
            "' class='" +
            customCufflinkStyleSelectId +
            "' data-target='" +
            $this.find("select").attr("id") +
            "'></ul>"
          );
          $options.each(function () {
            var $option = jQuery(this);
            jQuery("#" + customCufflinkStyleSelectId).append(
              "<li class='" +
              $option.text().toLowerCase().split(" ").join("-") +
              "' data-desc-target='" +
              $option.text().toLowerCase().split(" ").join("-") +
              "' data-val='" +
              $option.text() +
              "'><div class='image'></div><h6>" +
              $option.text() +
              "</h6></li>"
            );
          });

          jQuery("#" + customCufflinkStyleSelectId + " li").click(function () {
            var $this = jQuery(this);
            var selectedVal = $this.attr("data-val");
            var targetSelectId = $this.parents("ul").attr("data-target");
            var $select = jQuery("#" + targetSelectId);

            jQuery(
              "#" + customCufflinkStyleSelectId + " li.active"
            ).removeClass("active");
            $this.addClass("active");
            $select.val(selectedVal).change();
          });
          break;

        case "Earring Style":
          $this.hide();
          var customEarringStyleSelectId =
            heading.toLowerCase().split(" ").join("-") + "-choice";
          $customElementWrapper.append(
            "<h5 class='custom-variant-title text-left'>Earring Style</h5><ul id='" +
            customEarringStyleSelectId +
            "' class='" +
            customEarringStyleSelectId +
            "' data-target='" +
            $this.find("select").attr("id") +
            "'></ul>"
          );

          $options.each(function () {
            var $option = jQuery(this);
            jQuery("#" + customEarringStyleSelectId).append(
              "<li class='" +
              $option.text().toLowerCase().split(" ").join("-") +
              "' data-desc-target='" +
              $option.text().toLowerCase().split(" ").join("-") +
              "' data-val='" +
              $option.text() +
              "'><div class='image'></div><h6>" +
              $option.text() +
              "</h6></li>"
            );
          });

          jQuery("#" + customEarringStyleSelectId + " li").click(function () {
            var $this = jQuery(this);
            var selectedVal = $this.attr("data-val");
            var targetSelectId = $this.parents("ul").attr("data-target");
            var $select = jQuery("#" + targetSelectId);

            jQuery("#" + customEarringStyleSelectId + " li.active").removeClass(
              "active"
            );
            $this.addClass("active");
            $select.val(selectedVal).change();
          });
          break;
      }
    });
  }

  //Toggling the product description when the 'customise' button is clicked
  jQuery("#customise-toggle a").click(function (event) {
    var $this = jQuery(this);
    if ($this.attr("id") == "#") {
      event.preventDefault();
    }
  });

  //News mobile nav
  jQuery("#news-categories-toggle").click(function () {
    var nav = jQuery(".blog-header .blog-nav");
    if (!nav.hasClass("open")) {
      jQuery(this).addClass("is-active");
      nav.slideDown().addClass("open");
    } else {
      jQuery(this).removeClass("is-active");
      nav.slideUp().removeClass("open");
    }
  });

  var stonesParam = Shopify.queryParams.stones;
  var stockParam = Shopify.queryParams.stock;
  var priceParam = Shopify.queryParams.price;
  var sortParam = Shopify.queryParams.sort_by;

  if (
    stonesParam != undefined ||
    stockParam != undefined ||
    priceParam != undefined ||
    sortParam != undefined
  ) {
    jQuery("#clear").show();
    jQuery("#clearMobile").show();
    jQuery("#clearSortMobile").show();
    jQuery(".clear-all-active-filter ").hide();
  }

  jQuery(".product").each(function () {
    var $this = jQuery(this);
    var remove = false;

    if (stonesParam != undefined) {
      if (!$this.hasClass("stone-" + stonesParam)) {
        remove = true;
      }
    }

    if (stockParam != undefined) {
      if (stockParam == "in-stock" && $this.hasClass("sold-out")) {
        remove = true;
      } else if (stockParam == "pre-order" && !$this.hasClass("sold-out")) {
        remove = true;
      }
    }

    if (priceParam != undefined) {
      $(".filter-main").addClass("collection_active");
      if (!$this.hasClass(priceParam)) {
        remove = true;
      }
    }

    if (remove == true) {
      $this.parent().remove();
    }
  });

  jQuery(".drop-a-hint a").click(function (event) {
    event.preventDefault();
    document.getElementById("dropahint-cta").click();
  });

  jQuery(".dropdown-menu ul li").mouseenter(function () {
    var $this = jQuery(this);
    var target = $this.attr("data-image");
    var $activeImage = jQuery(".dropdown-menu .images .image.active");
    var $targetImage = jQuery(
      ".dropdown-menu .images .image." + (target != "" ? target : "default")
    );

    $activeImage.removeClass("active");
    $targetImage.addClass("active");
  });

  jQuery(".dropdown-menu ul li").mouseleave(function () {
    jQuery(".dropdown-menu .images .image.active").removeClass("active");
  });

  jQuery("#product-accordion .panel-title#reviews-toggle").click(function () {
    var $popup = jQuery("#reviews-popup");

    if (!$popup.hasClass("open")) {
      $popup.addClass("open");
      jQuery("body").addClass("lock");
      $popup.find("textarea").attr("rows", 5);
    } else {
      $popup.removeClass("open");
      jQuery("body").removeClass("lock");
    }
  });

  jQuery("#reviews-popup .close").click(function () {
    jQuery(this).parents("#reviews-popup").removeClass("open");
    jQuery("body").removeClass("lock");
  });

  //Trigger the engrave function
  jQuery("#engrave-toggle").click(function (event) {
    var $overlay = jQuery("#engrave-overlay");
    var $popup = jQuery("#engrave-popup");

    event.preventDefault();
    if (!$popup.hasClass("open")) {
      $overlay.addClass("open");
      jQuery("body").addClass("lock");
      $popup.addClass("open");
      $(".nav-bar.desktop--hide").addClass("zindex-change");
    } else {
      $overlay.removeClass("open");
      jQuery("body").removeClass("lock");
      $popup.removeClass("open");
      $(".nav-bar.desktop--hide").removeClass("zindex-change");
    }
  });

  jQuery("#engrave-popup .modal .modal-header .close").click(function (event) {
    event.preventDefault();
    jQuery(this).parents("#engrave-popup").removeClass("open");
    jQuery("body").removeClass("lock");
  });

  jQuery("#engrave-popup #finish").click(function (event) {
    event.preventDefault();
    jQuery(this).parents("#engrave-popup").removeClass("open");
    jQuery("body").removeClass("lock");
    jQuery("button[name='add']").click();
  });

  //Making the cart popout width of the screen on mobile
  if (jQuery(window).width() <= 414) {
    //jQuery(".site-nav--mobile .cart-popout").css({"width":jQuery(window).width()});
    //jQuery(".site-nav--mobile .cart-popout").hide();
  }

  jQuery(".AddToCartForm").on("submit", function (event) {
    event.preventDefault();

    jQuery.post(
      "/cart/add.js",
      jQuery(this).serialize(),
      function (resp) {
        if (typeof fetchCart === "function") {
          fetchCart();
        }
        if (typeof openCartDrawer === "function" && typeof openCartOverlay === "function") {
          openCartDrawer();
          openCartOverlay();
        } else {
          toggleCartPopout(".site-header__cart-toggle");
        }
      },
      "json"
    );
  });

  jQuery(".cart-table .quantity input[type='number']").focus(function () {
    jQuery(this).parent().addClass("active");
  });

  jQuery(".cart-table .quantity input[type='number']").blur(function () {
    jQuery(this).parent().removeClass("active");
  });

  //Triggers the customsie popup
  jQuery(".trigger-customise-popup").click(function (event) {
    var popup = jQuery("#customise-popup");
    event.preventDefault();
    if (!jQuery("#customise-popup").hasClass("open")) {
      popup.addClass("open");
      jQuery("body").addClass("lock");
    } else {
      popup.removeClass("open");
      jQuery("body").removeClass("lock");
    }
  });

  jQuery("#customise-popup .modal .close").click(function (event) {
    event.preventDefault();
    jQuery(this).parents("#customise-popup").removeClass("open");
    jQuery("body").removeClass("lock");
  });

  var firstSubmit = true;

  mobileSubnav();

  var $inTheNews = jQuery(".in-the-news");

  if ($inTheNews.length > 0) {
    var $slider = $inTheNews.find(".in-the-news__slides");
    var $publishers = $inTheNews.find(".in-the-news__publishers a");

    $slider.slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: "linear",
      swipe: false,
    });

    $publishers.click(function (e) {
      e.preventDefault();
      var slideIndex = jQuery(this).attr("data-index");

      jQuery(".in-the-news__publishers a.active").removeClass("active");
      jQuery(this).addClass("active");

      $slider.slick("slickGoTo", parseInt(slideIndex), false);
    });
  }
}); //document.ready()

var parseQueryString = function (url) {
  var urlParams = {};
  url.replace(
    new RegExp("([^?=&]+)(=([^&]*))?", "g"),
    function ($0, $1, $2, $3) {
      urlParams[$1] = $3;
    }
  );

  return urlParams;
};

document.onreadystatechange = function () {
  if (document.readyState == "complete") {
    var blogOptions = {
      itemSelector: ".blog-item",
      masonry: {
        columnWidth: ".blog-item",
      },
    };
    var $grid = jQuery("#news .grid").isotope(blogOptions);

    var urlToParse = location.search;
    var urlParams = parseQueryString(urlToParse);

    if (urlParams.cat != undefined && urlParams.cat.length > 0) {
      jQuery(".blog-item").each(function () {
        if (!jQuery(this).hasClass("cat-" + urlParams.cat)) {
          $grid.isotope("remove", this).isotope("layout");
        }
      });
    }

    var $pressGrid = jQuery("#press #press-articles").isotope({
      itemSelector: ".press-item",
      masonry: {
        columnWidth: ".press-item",
      },
    });

    jQuery("#press-category").change(function () {
      $pressGrid.isotope({
        filter: jQuery(this).val(),
      });
    });

    var navTop =
      jQuery(".nav-bar").length > 0 ? jQuery(".nav-bar").offset().top : null;
    var autoScrolled = false;
    var zeroReset = false;

    jQuery(window).on("scroll", function () {
      var windowPos = jQuery(window).scrollTop();

      initStickyNav(windowPos, navTop);

      // Changing quote colour scheme functionality
      var halfScreenPos = windowPos + jQuery(window).height() / 2;

      jQuery(".quote, .normal-note").each(function () {
        var $this = jQuery(this);
        var offset = $this.offset().top;
        if (offset < halfScreenPos) {
          if (!$this.hasClass("scrolled")) {
            $this.addClass("scrolled");
          }
        } else {
          if ($this.hasClass("scrolled")) {
            $this.removeClass("scrolled");
          }
        }
      });
    });

    if (jQuery("body").hasClass("template-product")) {
      prepEngrave();
    }

    stickyFooter();

    if (Shopify.queryParams.metal != undefined) {
      jQuery(
        "#metal-choice a[data-desc-target='" + Shopify.queryParams.metal + "']"
      ).click();
    } else {
      jQuery("#metal-choice li").first().find("a").click();
    }
  }
};

function toggleCartPopout(_this) {
  jQuery.get(
    "/cart.js",
    function (resp) {
      var $popout = jQuery(_this).find(".cart-popout");
      var cartCloneContents = jQuery("#cart-item").html();
      var $cartClone = jQuery(cartCloneContents);

      if (resp.items.length > 0) {
        jQuery(".site-header__cart-toggle .item-count").text(resp.item_count);
        if (jQuery(".site-header__cart-toggle .item-count").hasClass("empty")) {
          jQuery(".site-header__cart-toggle .item-count").removeClass("empty");
        }
        $popout.find(".grid").html("");

        jQuery.each(resp.items, function (key, val) {
          $cartClone.find("a").attr("href", val.url);
          $cartClone.find("img").attr("src", val.image).addClass("hidden");
          $cartClone.find(".item-title a").text(val.title);
          $cartClone
            .find(".item-price .money")
            .text((val.price / 100).toFixed(2));

          $popout.find(".grid").append($cartClone);
        });
        Currency.convertAll(shopCurrency, jQuery("[name=currencies]").val());
      }

      if (!$popout.hasClass("open")) {
        $popout.css({ visibility: "visible", opacity: 1 }).addClass("open");
      } else {
        $popout.css({ visibility: "hidden", opacity: 0 }).removeClass("open");
      }
    },
    "json"
  );
}

function initStickyNav(windowPos, navTop) {
  var $navBar = jQuery(".desktop_header, .nav-bar, .mobile-filter-popup");

  if (windowPos > 0) {
    $navBar.addClass("scrolling");
  } else {
    $navBar.removeClass("scrolling");
  }
}

function getMetalClass(val) {
  if (val.indexOf("9ct") !== -1) {
    var tempVal = val.replace("9ct-", "");
    return (tempVal += "-9ct");
  } else if (val.indexOf("14ct") !== -1) {
    var tempVal = val.replace("14ct-", "");
    return (tempVal += "-14ct");
  } else if (val.indexOf("18ct") !== -1) {
    var tempVal = val.replace("18ct-", "");
    return (tempVal += "-18ct");
  } else if (val.indexOf("22ct") !== -1) {
    var tempVal = val.replace("22ct-", "");
    return (tempVal += "-22ct");
  } else {
    return val;
  }
}

/**
 * Related tiles use desktop + mobile image columns; only one is visible per breakpoint.
 * Activating .model-image while the mobile column is visible leaves no .active img (grey tile).
 */
function ensureRelatedProductTileImage($product, cookieContents) {
  if (!$product || !$product.length) return;
  var $imgRoot = $product.find(".grid__image");
  if (!$imgRoot.length) return;
  var $desk = $imgRoot.find(".coll_img_desktop");
  var $mob = $imgRoot.find(".coll_img_mobile");
  /* Match template-product.css (361 / 360 breakpoints); :visible lies inside Slick slides */
  var useMobileCol =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(max-width: 360px)").matches;
  var $col;
  if (useMobileCol && $mob.length) {
    $col = $mob;
  } else if ($desk.length) {
    $col = $desk;
  } else {
    $col = $mob.length ? $mob : $imgRoot;
  }
  $imgRoot.find("img").removeClass("active").css("opacity", "");
  var pref = cookieContents;
  var $show =
    pref === "model" && $col.find("img.model-image").length
      ? $col.find("img.model-image").first()
      : $col.find("img.product-image").first();
  if (!$show || !$show.length) {
    $show = $col.find("img").first();
  }
  if ($show && $show.length) {
    $show.addClass("active").css("opacity", 1);
  }
}

function productImageChoice() {
  jQuery(".product-view span").click(function () {
    Cookies.set("product-view", jQuery(this).attr("data-for"));
    window.location.reload();
  });

  cookieContents =
    Cookies.get("product-view") != undefined
      ? Cookies.get("product-view")
      : "product";

  jQuery(".product-view span[data-for='" + cookieContents + "']").addClass(
    "active"
  );

  $(document).ready(function () {
    jQuery(".grid-uniform .grid__item").each(function () {
      if ($(this).find(".product")) {
        $(this).parents(":eq(1)").addClass("has-product");
      } else {
        $(this).parent(":eq(1)").addClass("no-product");
      }
    });
  });

  jQuery(".grid__item .product").each(function () {
    var $this = jQuery(this);

    /* Related carousel on PDP: always open on product shot; hover may show on-model */
    if ($this.closest("#related-products").length) {
      ensureRelatedProductTileImage($this, "product");
      return;
    }

    var $desk = $this.find(".grid__image .coll_img_desktop");
    var $prod = $desk.find("img.product-image");
    var $model = $desk.find("img.model-image");

    $this.find(".grid__image img").removeClass("active");
    $prod.addClass("active");

    /* Only show on-model when a model image exists; otherwise keep product shot */
    if (cookieContents === "model" && $model.length) {
      $model.addClass("active");
    }

    $this.off("mouseenter.productImgSwap mouseleave.productImgSwap");
    if (!$model.length || !$desk.length) {
      return;
    }

    /* Hover: show the alternate shot; leave: restore Product / On Model preference */
    $this.on("mouseenter.productImgSwap", function () {
      if (!$desk.is(":visible")) return;
      if (cookieContents === "model") {
        $model.removeClass("active");
      } else {
        $model.addClass("active");
      }
    });
    $this.on("mouseleave.productImgSwap", function () {
      if (!$desk.is(":visible")) return;
      if (cookieContents === "model") {
        $model.addClass("active");
      } else {
        $model.removeClass("active");
      }
    });
  });
}

function bindRelatedProductImageSwap() {
  var $container = jQuery("#related-products");
  if (!$container.length) return;
  var pref =
    jQuery("body").hasClass("template-product")
      ? "product"
      : typeof Cookies !== "undefined" && Cookies.get("product-view")
        ? Cookies.get("product-view")
        : "product";

  $container.find(".product").each(function () {
    ensureRelatedProductTileImage(jQuery(this), pref);
  });

  $container.off("mouseenter.relatedImgSwap mouseleave.relatedImgSwap", ".product");
  /* Match collection UX: hover shows alternate shot (on-model), leave restores cookie default */
  $container.on("mouseenter.relatedImgSwap", ".product", function () {
    var $p = jQuery(this);
    var $desk = $p.find(".grid__image .coll_img_desktop");
    if (!$desk.length || !$desk.is(":visible")) return;
    var $prod = $p.find(".grid__image img.product-image");
    var $model = $p.find(".grid__image img.model-image");
    if (!$prod.length || !$model.length) return;
    $prod.removeClass("active").stop().css({ opacity: 0 });
    $model.addClass("active").stop().css({ opacity: 1 });
  });
  $container.on("mouseleave.relatedImgSwap", ".product", function () {
    var $p = jQuery(this);
    var $desk = $p.find(".grid__image .coll_img_desktop");
    if (!$desk.length || !$desk.is(":visible")) return;
    var $prod = $p.find(".grid__image img.product-image");
    var $model = $p.find(".grid__image img.model-image");
    if (!$prod.length || !$model.length) return;
    var $show = pref === "model" ? $model : $prod;
    var $hide = pref === "model" ? $prod : $model;
    $hide.removeClass("active").stop().css({ opacity: 0 });
    $show.addClass("active").stop().css({ opacity: 1 });
  });
}

// // -- load more
// document.addEventListener("DOMContentLoaded", function() {
//   var endlessScroll = new Ajaxinate({
//     container: '.grid-uniform',
//     pagination: '#Huratips-Pagination'

//   });
// });
// $( window ).scroll(function() {
//   jQuery(".grid__item .product").each(function()
//   {
//     var $this = jQuery(this);
//     $this.mouseleave(function()
//      {
//       var $activeImage = $this.find("img.active");
//       var $newImage = $this.find("img").not(".active");
//       $activeImage.stop().animate({"opacity":0}, 400);
//       setTimeout(function()
//        {
//         $activeImage.removeClass("active");
//         $newImage.addClass("active");
//         $newImage.stop().animate({"opacity":1}, 400);
//       }, 410);
//     });
//   });
//   });
// // -----

function stickyFooter() {
  var windowHeight = jQuery(window).height();
  var bodyHeight = jQuery("body").height();

  if (windowHeight > bodyHeight) {
    jQuery("footer").addClass("sticky");
  } else {
    jQuery("footer").removeClass("sticky");
  }
}

function prepEngrave() {
  var stepNumbers = [];
  var steps = {};

  jQuery(".bold_options .bold_option").each(function () {
    var $option = jQuery(this);
    var optionTitle = $option.find(".bold_option_title").text().split("--");
    var stepNumber = parseInt(optionTitle[0].trim());

    if (stepNumbers.indexOf(stepNumber) == -1) {
      stepNumbers.push(stepNumber);
    }
  });

  for (var xx = 1; xx <= stepNumbers.length; xx++) {
    steps[xx] = [];

    jQuery(".bold_options .bold_option").each(function () {
      var $option = jQuery(this);
      var optionTitle = $option.find(".bold_option_title").text().split("--");
      var stepNumber = parseInt(optionTitle[0].trim());
      var $formElement = $option
        .find(".bold_option_element")
        .children()
        .first();

      if (stepNumber == xx) {
        var step = {
          title:
            $option.find(".bold_help_text small").text() != ""
              ? $option.find(".bold_help_text small").text()
              : "",
          fieldId: $formElement.attr("class"),
          elementType: $formElement.get(0).tagName.toLowerCase(),
        };

        if (step.elementType == "input") {
          step.inputType = $formElement.attr("type");
          step.charLim =
            $formElement.attr("maxlength") != ""
              ? parseInt($formElement.attr("maxlength"))
              : 0;
          step.inputFields = [];

          if (step.charLim > 0) {
            for (var yy = 0; yy < step.charLim; yy++) {
              step.inputFields.push(xx);
            }
          } else {
            step.inputFields.push(1);
          }
        }

        if (step.elementType == "select") {
          step.items = [];
          var itemCounter = 0;

          $formElement.find("option").each(function () {
            if (itemCounter > 0) {
              var item = {
                val: jQuery(this).val(),
                content: jQuery(this).text(),
              };

              if (stepNumber == 2) {
                var assetUrlParts = assetUrl.split("/");
                assetUrlParts.pop();
                var rootAssetUrl = assetUrlParts.join("/");

                item.imageSrc =
                  rootAssetUrl +
                  "/" +
                  item.content.toLowerCase().replace(" ", "-") +
                  ".jpg";
              }

              step.items.push(item);
            }

            itemCounter++;
          });

          step.default = step.items[0].content;
        }

        steps[xx].push(step);
      }
    });
  }

  _.templateSettings.variable = "rc";
  var _stepTemplate = _.template(jQuery("#step-template").html());
  var _stepNumberTemplate = _.template(jQuery("#step-number-template").html());

  for (var xx = 1; xx <= stepNumbers.length; xx++) {
    var data = {
      currentStep: xx,
      current: xx == 1 ? "current" : "",
      fields: [],
    };

    jQuery(steps[xx]).each(function () {
      var $step = jQuery(this).get(0);

      data.fields.push($step);
    });

    if (_stepTemplate) {
      var html = _stepTemplate(data);

      jQuery("#engrave .steps").append(html);
    }
  }

  var data = {
    steps: stepNumbers,
  };

  if (_stepNumberTemplate) {
    var html = _stepNumberTemplate(data);
    jQuery("#engrave .nav").append(html);
  }

  jQuery("#step-1").show();

  jQuery("#engrave .custom-select .current").click(function (event) {
    var $this = jQuery(this);
    var $wrapper = $this.parents(".custom-select");
    var $items = $wrapper.find(".items");
    var $select = jQuery("select." + $wrapper.attr("data-for"));

    $items.toggle();

    $items.find(".item").click(function () {
      var $item = jQuery(this);
      $this.text($item.text());
      $select.val($item.attr("data-val")).change();
      $items.hide();
    });
  });

  jQuery("#engrave .custom-button").click(function () {
    event.preventDefault();
    var $this = jQuery(this);

    switch ($this.attr("data-field-type")) {
      case "file":
        jQuery("input." + $this.attr("data-for"))
          .focus()
          .trigger("click");
        break;
    }
  });

  jQuery(".char-field").on("keyup", function () {
    var $this = jQuery(this);
    var $next = $this.next();
    var $siblings = $this.siblings();
    var cont = true;

    if ($this.hasClass("limit-numeric")) {
      var input = $this.val();

      if (isNaN(input)) {
        cont = false;
        $this.val("");
      }
    }

    if (cont) {
      if (
        $this.parents(".date-field-group").length > 0 &&
        $this.hasClass("last")
      ) {
        $this.parent().next().find("input[type='text']").first().focus();
      } else {
        $next.focus();
      }
    }

    if ($this.parents(".date-field-group").length > 0) {
      var date = {
        day: "",
        month: "",
        year: "",
      };

      $this
        .parents(".date-field-group")
        .find(".day input")
        .each(function () {
          date.day = date.day + jQuery(this).val();
        });

      $this
        .parents(".date-field-group")
        .find(".month input")
        .each(function () {
          date.month = date.month + jQuery(this).val();
        });

      $this
        .parents(".date-field-group")
        .find(".year input")
        .each(function () {
          date.year = date.year + jQuery(this).val();
        });

      jQuery(
        "input." + $this.parents(".date-field-group").attr("data-for")
      ).val(date.year + "-" + date.month + "-" + date.day);
    }

    if ($this.parents(".multi-char-fields").length > 0) {
      var inputText = "";

      $this
        .parent()
        .find("input")
        .each(function () {
          inputText = inputText + jQuery(this).val();
        });

      jQuery("input." + $this.parent().attr("data-for")).val(inputText);
    }
  });

  jQuery("#engrave .step textarea").on("keyup", function () {
    jQuery("textarea." + jQuery(this).attr("data-for")).val(jQuery(this).val());
  });

  jQuery("#engrave .step a.next").click(function (event) {
    event.preventDefault();

    var $this = jQuery(this);
    var $currentStep = $this.parents(".step");
    var currentStepNumber = parseInt($this.attr("data-step"));
    var $nextStep = jQuery("#step-" + (currentStepNumber + 1));

    $currentStep.fadeOut(400);
    setTimeout(function () {
      $currentStep.removeClass("current");
      $nextStep.fadeIn(400);

      setTimeout(function () {
        $nextStep.addClass("current");
      }, 410);
    }, 410);
  });

  jQuery("#engrave .nav a").click(function (event) {
    event.preventDefault();
    var $this = jQuery(this);
    var $targetStep = jQuery("#step-" + parseInt($this.text()));
    var $currentStep = jQuery("#engrave .step.current");

    $currentStep.fadeOut(400);

    setTimeout(function () {
      $currentStep.removeClass("current");
      $targetStep.fadeIn(400);

      setTimeout(function () {
        $targetStep.addClass("current");
      }, 410);
    }, 410);
  });
}

function mobileSubnav() {
  jQuery(".mobile-nav__has-sublist a.has-dropdown").click(function (event) {
    event.preventDefault();
  });
}

$(document).ready(function () {
  $(".mobile-product-grid__image").on("click", function () { });
});

$(".mobile-dropdown-button").click(function () {
  $(".mobile-dropdown-button").removeClass("active");
  $(this).addClass("active");
  if ($(".mobile-nav__sublist").is(":visible")) {
    $(".third-tier").slideUp(300);
    $(this).next(".third-tier").removeClass("active");
    $(this).removeClass("active");
  }
  if ($(this).next(".third-tier").is(":visible")) {
    $(this).next(".third-tier").slideUp("slow");
    $(this).next(".third-tier").removeClass("active");
    $(this).removeClass("active");
  } else {
    $(this).next(".third-tier").slideDown("slow");
    $(this).next(".third-tier").addClass("active");
    $(this).addClass("active");
  }
});

$(".accordion__heading").on("click", function () {
  $(this).parent().toggleClass("active");
  $(this).parent().find(".accordion__content").slideToggle();
});

$(
  '.second-div-txt a[href^="#"] ,#shopify-section-page-bespoke-banner a[href^="#"] ,#shopify-section-banner-engagement a[href^="#"]'
).on("click", function (e) {
  e.preventDefault();
  var target = this.hash;
  var $target = $(target);
  $("html, body")
    .stop()
    .animate(
      {
        scrollTop: $target.offset().top,
      },
      900,
      "swing",
      function () {
        // window.location.hash = target;
      }
    );
});

$(document).ready(function () {
  $(".item").click(function () {
    $("html,body").animate(
      {
        scrollTop: $(".block").offset().top,
      },
      "slow"
    );
  });
});

$(document).on("click", ".item", function () {
  var checkBoxes = $(this).find("input[type=radio]");
  checkBoxes.prop("checked", !checkBoxes.prop("checked"));
  var windowWidth = $(window).width();
  if (windowWidth < 870) {
    if (checkBoxes.prop("checked")) {
      //console.log('test 1');
      $("body").addClass("collapse");
    } else {
      //console.log('test 2');
      $("body").removeClass("collapse");
    }
  }
});

$(document).ready(function () {
  $("ul.tabs").each(function () {
    var $list = $(this);
    var $scope = $list.closest(".tab-main-div");
    var links = $list.find("a").filter(function () {
      return $(this).parent().css("display") !== "none";
    });
    if (!links.length) return;

    var active = links.eq(0).addClass("active");
    var content = $scope.length
      ? $scope.find(active.attr("href"))
      : $(active.attr("href"));

    links.not(":eq(0)").each(function () {
      var $panel = $scope.length
        ? $scope.find($(this).attr("href"))
        : $($(this).attr("href"));
      $panel.hide();
    });
    content.show();
    content
      .find(".panel-content")
      .css({ display: "block", height: "auto", overflow: "visible" });

    $list.find("a").on("click", function (e) {
      if ($(this).parent().css("display") === "none") return false;
      e.preventDefault();
      active.removeClass("active");
      content.hide();
      active = $(this);
      content = $scope.length
        ? $scope.find($(this).attr("href"))
        : $($(this).attr("href"));
      active.addClass("active");
      content.show();
      content
        .find(".panel-content")
        .stop(true, true)
        .show()
        .css({ display: "block", height: "auto", overflow: "visible" });
      return false;
    });
  });
});

$(document).ready(function () {
  $(".site-header").mouseenter(function () {
    $(this).addClass("hover-menu");
  });
  $(".site-header").mouseleave(function () {
    $(this).removeClass("hover-menu");
  });
  $("li.desktop-search").click(function (event) {
    /* Clicks on the close X bubble through this <li>; hide()+show() would reopen the drawer and stopPropagation blocked the document delegated close handler. */
    if ($(event.target).closest("a.close_btn, .close_btn").length) {
      return;
    }
    $(".desk-search-drawer").hide();
    $(".desk-search-drawer").show();
    event.stopPropagation();
  });
  /* Desk search: dismiss when clicking outside (not when interacting inside drawer or opening it). */
  $("body").on("click", function (event) {
    if (
      $(event.target).closest(
        ".desk-search-drawer, li.desktop-search, li.search.desktop-search"
      ).length
    ) {
      return;
    }
    $(".desk-search-drawer").hide();
  });

  $(".site-nav").on("mouseleave", function () {
    $(".menu-ams").removeClass("add-animation");
    $(".menu-ams").removeClass("remove-animation");
  });
});

// Initialize related products carousel (Slick; legacy markup used class "owl-carousel")
function initRelatedProductsSlick() {
  var $relatedProducts = jQuery("#related-products");
  if (
    !$relatedProducts.length ||
    !$relatedProducts.children().length ||
    typeof jQuery.fn.slick !== "function"
  ) {
    return;
  }

  $relatedProducts.removeClass("owl-carousel");

  if ($relatedProducts.data("owl.carousel")) {
    try {
      $relatedProducts.trigger("destroy.owl.carousel");
    } catch (e) { }
    $relatedProducts.removeData("owl.carousel");
  }

  if ($relatedProducts.hasClass("slick-initialized")) {
    try {
      $relatedProducts.slick("unslick");
    } catch (e) { }
  }

  var slideCount = $relatedProducts.children().length;
  if (slideCount < 1) return;

  /* Single slide: skip Slick (unreliable sizing) */
  if (slideCount === 1) {
    $relatedProducts.addClass("related-products--single");
    bindRelatedProductImageSwap();
    return;
  }

  $relatedProducts.removeClass("related-products--single");

  var slidesDesktop = Math.min(4, slideCount);
  var slides1024 = Math.min(3, slideCount);
  var slides768 = Math.min(2, slideCount);
  var slides480 = Math.min(2, slideCount);
  var useInfinite = slideCount > slidesDesktop;

  try {
    $relatedProducts.slick({
      dots: slideCount > slidesDesktop,
      arrows: true,
      infinite: useInfinite,
      adaptiveHeight: true,
      speed: 300,
      slidesToShow: slidesDesktop,
      slidesToScroll: 1,
      prevArrow:
        "<button type='button' class='slick-prev slick-arrow' aria-label='Previous'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'><polyline points='15,18 9,12 15,6'></polyline></svg></button>",
      nextArrow:
        "<button type='button' class='slick-next slick-arrow' aria-label='Next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'><polyline points='9,6 15,12 9,18'></polyline></svg></button>",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: slides1024,
            slidesToScroll: 1,
            infinite: slideCount > slides1024,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: slides768,
            slidesToScroll: 1,
            infinite: slideCount > slides768,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            infinite: slideCount > slides480,
            slidesToShow: slides480,
            slidesToScroll: 1,
            variableWidth: false,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
          },
        },
      ],
    });
  } catch (err) {
    if (typeof console !== "undefined" && console.warn) {
      console.warn("Related products Slick init failed:", err);
    }
    return;
  }

  $relatedProducts.off("reInit.relatedSwap breakpoint.relatedSwap");
  $relatedProducts.on("reInit.relatedSwap breakpoint.relatedSwap", function () {
    bindRelatedProductImageSwap();
  });
  bindRelatedProductImageSwap();
}

$(document).ready(function () {
  $(".slider-gallery, .customer-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    fade: false,
    speed: 300,
    cssEase: "ease-in-out",
    touchThreshold: 100,
  });

  $(".favorite-single-item").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    fade: false,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 2000,
    lazyLoad: "ondemand",
    cssEase: "ease-in-out",
    touchThreshold: 100,
  });

  initRelatedProductsSlick();

  jQuery(window).on("load", function () {
    initRelatedProductsSlick();
  });

  var relatedProductsResizeTimer;
  jQuery(window).on("resize orientationchange", function () {
    clearTimeout(relatedProductsResizeTimer);
    relatedProductsResizeTimer = setTimeout(function () {
      var $rp = jQuery("#related-products");
      if (!$rp.length || !$rp.hasClass("slick-initialized")) {
        return;
      }
      try {
        $rp.slick("setPosition");
      } catch (e) {}
      bindRelatedProductImageSwap();
    }, 200);
  });
});

document.addEventListener("shopify:section:load", function (ev) {
  if (
    ev.target &&
    ev.target.querySelector &&
    ev.target.querySelector("#related-products")
  ) {
    initRelatedProductsSlick();
  }
});
if ($(window).width() <= 767) {
  $(".mobileHide .modelmobile").click();
  $(".mobileHide .modelmobile").addClass("active");
}
$(".closeFiletr").click(function () {
  $(".filter-toggles a:nth-child(1)").click();
  $("body").removeClass("no-scroll");
  $(".mobile-filter-popup").removeClass("mobile-filter-popup-fixed");
});
$(".closeIconFiletrSort").click(function () {
  $(".filter-toggles a:nth-child(2)").click();
  $("body").removeClass("no-scroll");
  $(".mobile-filter-popup").removeClass("mobile-filter-popup-fixed");
});

$(document).ready(function () {
  $("#metal-choice .yellow-gold-9ct a, #metal-choice .yellow-gold-18ct a, #metal-choice .yellow-gold-14ct a").click(function () {
    $(".silver-dipped").hide();
    $(".silver-gold").hide();
    $(".yellow-gold").show();
    $(".white-gold").hide();
  });
  $("#metal-choice .white-gold-9ct a").click(function () {
    $(".silver-dipped").hide();
    $(".silver-gold").hide();
    $(".white-gold").show();
    $(".yellow-gold").hide();
  });
  $("#metal-choice .silver a").click(function () {
    $(".silver-dipped").hide();
    $(".silver-gold").show();
    $(".yellow-gold").hide();
    $(".white-gold").hide();
  });
  $("#metal-choice .yellow-gold-dipped a").click(function () {
    $(".silver-dipped").show();
    $(".silver-gold").hide();
    $(".yellow-gold").hide();
    $(".white-gold").hide();
  });
  $("#metal-choice .platinum a").click(function () {
    $(".silver-dipped").hide();
    $(".silver-gold").hide();
    $(".yellow-gold").hide();
    $(".white-gold").show();
  });
});

$(".site-nav--mobile").on("click", function () {
  if ($(".menu-btn").is(":checked")) {
    $("body").css("overflow", "hidden");
    $(".mobile-filter-popup").hide();
    $(".nav-bar, .site-header").addClass("scrolling");
  } else {
    $("body").css("overflow", "auto");
    $(".mobile-filter-popup").show();
  }
});

$(document).ready(function () {
  function numberWithCommas(number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  setTimeout(function () {
    var reviewsWidget = $("#R-ReviewsList--reviewsio-carousel-widget");
    var numItems = reviewsWidget.length > 0 ? reviewsWidget.find(".R-ReviewsList__item").length : 0;
    var $carouselRoot = $("#reviewsio-carousel-widget");

    // Hide reviews section if no reviews or if widget didn't render at all
    if (numItems == 0 || reviewsWidget.length == 0) {
      $(".reviews-headng").hide();
    }
    // Scroll only for 4+ reviews. 1 = centered; 2 = natural width (no stretch); 3 = static row.
    var $section = $(".reviews-headng");
    $carouselRoot.removeClass("reviews-single reviews-duo reviews-no-scroll");
    $section.removeClass("reviews-single reviews-duo reviews-no-scroll");
    if (numItems > 0 && numItems <= 3) {
      $carouselRoot.addClass("reviews-no-scroll");
      $section.addClass("reviews-no-scroll");
      if (numItems === 1) {
        $carouselRoot.addClass("reviews-single");
        $section.addClass("reviews-single");
      } else if (numItems === 2) {
        $carouselRoot.addClass("reviews-duo");
        $section.addClass("reviews-duo");
      }
    }
    
    if (numItems > 0 || reviewsWidget.length > 0) {
      $carouselRoot.addClass("reviews-initialized");
      $section.addClass("reviews-initialized");
    }
    // Check arrow visibility for thumbnails slider
    // For remodelling template, check all slides including non-active ones
    var $thumbs = $("#thumbs");
    var arrow = 0;

    if ($('.remodelling-product').length) {
      // For remodelling, count all divs inside slider-nav, not just slick-slide
      arrow = $thumbs.find('> div').length;
      // Also check slick-slide count as fallback
      var slickSlides = $thumbs.find(".slick-slide").length;
      if (slickSlides > arrow) {
        arrow = slickSlides;
      }
    } else {
      arrow = $thumbs.find(".slick-slide").length;
    }

    //console.log('arrow',arrow);
    if (arrow <= 4) {
      $(".slick-next-prev-arrow").hide();
      //$("#thumbs .slick-list").css("height","auto !important");
      var slick = $("#thumbs .slick-list");
      $(slick).addClass("height");
    } else {
      $(".slick-next-prev-arrow").show();
    }
    if (arrow <= 1) {
      $("#thumbs .slick-list").hide();
    }
    $("select.single-option-selector").change(function () {
      var arrow = 0;
      if ($('.remodelling-product').length) {
        arrow = $thumbs.find('> div').length;
        var slickSlides = $thumbs.find(".slick-slide").length;
        if (slickSlides > arrow) {
          arrow = slickSlides;
        }
      } else {
        arrow = $thumbs.find(".slick-slide").length;
      }

      if (arrow <= 4) {
        $(".slick-next-prev-arrow").hide();
        //$("#thumbs .slick-list").css("height","auto !important");
        var slick = $("#thumbs .slick-list");
        $(slick).addClass("height");
      } else {
        $(".slick-next-prev-arrow").show();
      }
      if (arrow <= 1) {
        $("#thumbs .slick-list").hide();
      }
    });
  }, 2700);

  $(function () {
    $(".iframe-vdo").fancybox({
      maxWidth: 640,
      maxHeight: 360,
      fitToView: false,
      width: "100%",
      height: "100%",
      autoSize: false,
      closeClick: false,
      openEffect: "none",
      closeEffect: "none",
      iframe: {
        scrolling: "auto",
        preload: true,
      },
    });
  });

  if ($(".coll-filter li").hasClass("tag--active")) {
    $(".filter-toggles a.filter-main").addClass("collection_active");
  }
  if ($('.menu-btn input[type="checkbox"]').is(":checked")) {
    $(".mobile-filter-popup").hide();
  } else {
    $(".mobile-filter-popup").show();
  }
  $(".close-cart").on("click", function () {
    $(".cart-popout").removeClass("open");
    $(".cart-popout").css({ visiubility: "hidden", opacity: 0 });
  });
  var text = $(".out-of-stock-msg").text().length;
  if (text <= 0) {
    $(".out-of-stock-msg").css("opacity", "0");
  }

  var silver =
    "https://metals-api.com/api/latest?access_key=j2sub6t8wu10ehge52f2exrklq3j286h1utrxth460725n39419xaml1rynq&base=GBP&symbols=XAG";
  var gold =
    "https://metals-api.com/api/carat?access_key=j2sub6t8wu10ehge52f2exrklq3j286h1utrxth460725n39419xaml1rynq&base=GBP&symbols=XAU";
  var platinum =
    "https://metals-api.com/api/latest?access_key=j2sub6t8wu10ehge52f2exrklq3j286h1utrxth460725n39419xaml1rynq&base=GBP&symbols=XPT";

  var gmPrice = "30"; //Carat (Ct) s a unit of mass that is equal to 0.00643 Troy Ounce, or 200 mg, or 0.2 gram.

  // Desktop Calculator
  function calculateGold(json, glv1, glv2, glv3, glv4) {
    let breakdown = [];
    let totalglv = 0;

    function calculate(value, weight, carat) {
      // Market value per gram * weight (no percentage changes)
      const marketValue = value * weight;
      totalglv += marketValue;

      breakdown.push({
        type: `${carat} Gold`,
        grams: weight,
        marketValue: marketValue.toFixed(2),
        lylieCredit: marketValue.toFixed(2), // Same as market value
      });
    }

    if (glv1) calculate(json.rates["9K"], glv1, "9ct");
    if (glv2) calculate(json.rates["14K"], glv2, "14ct");
    if (glv3) calculate(json.rates["18K"], glv3, "18ct");
    if (glv4) calculate(json.rates["22K"], glv4, "22ct");

    return { total: totalglv, breakdown };
  }

  $(".ge-btn").on("click", function () {
    let breakdowns = [];
    let totalAmount = 0;

    function processMetal(apiUrl, weight, type, callback) {
      if (weight > 0) {
        $.ajax({
          type: "GET",
          url: apiUrl,
          async: false,
          dataType: "json",
          success: function (json) {

            const ratePerTroyOunce = json.rates.XPT;
            const ratePerGram = ratePerTroyOunce / 31.28;
            const purity = 1.04;
            const marketValue = ratePerGram * weight * purity;

            breakdowns.push({
              type: `${type} Platinum`,
              grams: weight,
              marketValue: marketValue.toFixed(2),
              lylieCredit: marketValue.toFixed(2),
            });

            totalAmount += marketValue;
            if (callback) callback();
          }
        });
      }
    }


    let glv1 = parseFloat($(".gold-gm1").val());
    let glv2 = parseFloat($(".gold-gm2").val());
    let glv3 = parseFloat($(".gold-gm3").val());
    let glv4 = parseFloat($(".gold-gm4").val());

    if (glv1 > 0 || glv2 > 0 || glv3 > 0 || glv4 > 0) {
      $.ajax({
        type: "GET",
        url: gold,
        async: false,
        dataType: "json",
        success: function (json) {
          const { total, breakdown } = calculateGold(json, glv1, glv2, glv3, glv4);
          breakdowns = breakdowns.concat(breakdown);
          totalAmount += total;
        },
      });
    }

    let ptnmv = parseFloat($(".platinum-gm").val());
    processMetal(platinum, ptnmv, "850");

    // Now print the breakdown dynamically
    let tableHtml = "<table>";
    tableHtml +=
      "<tr><th>Metal Type</th><th>Grams</th><th>Market<br/>Value</th><th>LYLIE<br/>Credit</th></tr>";
    breakdowns.forEach((item) => {
      tableHtml += `<tr><td>${item.type}</td><td>${item.grams}g</td><td>£${item.marketValue}</td><td class="total">£${item.lylieCredit}</td></tr>`;
    });

    // Totals (same for both)
    //const totalLylieCredit = totalAmount;
    const totalLylieCredit = Math.round(totalAmount * 1.25 * 0.8 * 100) / 100; // Ensure consistent rounding and deduction

    tableHtml += `<tr><td colspan="1">TOTAL</td><td></td><td>£${totalAmount.toFixed(
      2
    )}</td><td>£${totalLylieCredit.toFixed(2)}</td></tr>`;
    tableHtml += "</table>";

    $(".calculated-results").html(tableHtml);
    $(".total-amount input").val(totalLylieCredit.toFixed(2));
  });


  //mobile calculator
  $(".add-btn1").on("click", function () {
    $(this).hide();
    $(".metal2-detail").show();
  });

  $(".add-btn2").on("click", function () {
    $(this).hide();
    $(".metal3-detail").show();
    $(".metal3-detail").css("padding-bottom", "115px");
  });
  $(".add-btn3").on("click", function () {
    $(this).hide();
    $(".metal4-detail").show();
    $(".metal3-detail").css("padding-bottom", "0");
    $(".metal4-detail").css("padding-bottom", "115px");
  });
  $(".add-btn4").on("click", function () {
    $(this).hide();
    $(".metal5-detail").show();
    $(".metal4-detail").css("padding-bottom", "0");
    $(".metal5-detail").css("padding-bottom", "115px");
  });
  $(".add-btn5").on("click", function () {
    $(this).hide();
    $(".metal6-detail").show();
  });

  $(".ge-back-btn").on("click", function () {
    $(this).hide();
    $(".mobile-metal-result").hide();
    $(".mobile-calc-btn, .mobile-metal-options").show();
    $(".request_btn").hide();
  });
  $(".request_btn").on("click", function () {
    $(this).hide();
    $(".modal_calc").hide();
    $(".modal_request").show();
    $(".ge-back-btn-form").show();
    $(".thank_you_modal").hide();
    $(".btn_explore").hide();
  });

  $(".ge-back-btn-form").on("click", function () {
    $(this).hide();
    $(".modal_request").hide();
    $(".thank_you_modal").hide();
    $(".btn_explore").hide();
    $(".modal_calc, .mobile-metal-result").show();
    $(".request_btn").show();
  });

  $(".btn_submit_cnt").on("click", function (event) {
    event.preventDefault(); // Prevent form submission

    let isValid = true; // Track form validity
    const form = $(this).closest("form");

    // List of fields to validate
    const fields = [
      {
        field: form.find("input[name='contact[name]']"),
        message: "Your name is required.",
      },
      {
        field: form.find("input[name='contact[email]']"),
        message: "Your email is required.",
        validate: validateEmail,
        invalidMessage: "Please enter a valid email address.",
      },
      {
        field: form.find("input[name='contact[telephone]']"),
        message: "Your telephone is required.",
      },
      {
        field: form.find("input[name='contact[Address]']"),
        message: "Your address is required.",
      },
    ];

    // Clear previous errors
    form.find(".error-message").remove();
    form.find("input").removeClass("error");

    // Validate each field and stop at the first invalid one
    for (const { field, message, validate, invalidMessage } of fields) {
      if (field.length && !field.val()?.trim()) {
        showError(field, message);
        isValid = false;
        field.focus(); // Focus the first invalid field
        break; // Stop after the first error
      } else if (validate && !validate(field.val())) {
        showError(field, invalidMessage);
        isValid = false;
        field.focus(); // Focus the first invalid field
        break; // Stop after the first error
      }
    }

    if (isValid) {
      // Form is valid, proceed with form submission logic
      $(this).hide();
      $(".modal_calc").hide();
      $(".modal_request").hide();
      $(".thank_you_modal").show();
      $(".btn_explore").show();
    }
  });

  // Helper function to display errors
  function showError(field, message) {
    field.addClass("error");
    field.after(`<span class="error-message">${message}</span>`);
  }

  // Function to show error messages
  function showError(input, message) {
    // Remove existing error message for this field
    input.siblings(".error-message").remove();

    input.addClass("error"); // Add error class for styling
    input.after(
      `<span class="error-message" style="color: red;">${message}</span>`
    ); // Append error message
    input.focus(); // Focus on the first invalid field
  }

  // Function to validate email format
  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  // Function to show error messages
  function showError(input, message) {
    input.addClass("error"); // Add error class for styling
    input.after(
      `<span class="error-message" style="color: red;">${message}</span>`
    ); // Display error message
    input.focus(); // Focus on the first invalid field
  }

  // Function to validate email format
  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  $(".ge-part2-inner #ge-calc-toggle").on("click", function () {
    $(".modal_calc").hide();
    $(".thank_you_modal").hide();
    $(".btn_explore").hide();
    $(".mobile-calc-btn").hide();
    $(".request_btn").hide();
    $(".thank_you_modal").addClass("thank_modal_two");
    $(".modal_request").show();
    $(".btn_submit_cnt").show();
  });

  $("#metal1, #metal2, #metal3, #metal4, #metal5, #metal6").on(
    "change",
    function () {
      var metal = $(this).find("option:selected").val();
      if (metal == "SILVER") {
        $(this).parents(".metal-detail").find(".silver-metal-weight").show();
        $(this)
          .parents(".metal-detail")
          .find(".gold-metal-weight, .platinum-metal-weight, .default-metal")
          .hide();
      }
      if (metal == "GOLD") {
        $(this).parents(".metal-detail").find(".gold-metal-weight").show();
        $(this)
          .parents(".metal-detail")
          .find(".silver-metal-weight, .platinum-metal-weight, .default-metal")
          .hide();
      }
      if (metal == "PLATINUM") {
        $(this).parents(".metal-detail").find(".platinum-metal-weight").show();
        $(this)
          .parents(".metal-detail")
          .find(".gold-metal-weight, .silver-metal-weight, .default-metal")
          .hide();
      }
    }
  );

  // $(".mobile-calc-btn").on("click", function () {
  //   $(this).hide();
  //   $(".mobile-metal-options").hide();

  //   let totalglvmo = 0;
  //   let totalptvmo = 0;
  //   let breakdown = [];

  //   // Show loading spinner or placeholder
  //   $(".mobile-result-inner").html(
  //     '<div class="loading-spinner">Loading...</div>'
  //   );
  //   $(".mobile-metal-result, .ge-back-btn").show(); // Immediately show the tab
  //   $(".request_btn").show(); // Show the request button

  //   const goldPromises = [];
  //   const platinumPromises = [];

  //   $(".metal-detail").each(function () {
  //     const $this = $(this);
  //     const metal = $this.find(".mobile-metal").val();
  //     const val = parseFloat($this.find(".metal-gm").val());
  //     const carat = $this
  //       .find(".gold-metal-weight option:selected")
  //       .attr("data-carat");

  //     if (metal === "GOLD") {
  //       const goldValues = {
  //         "Carat 9K": [val, 0, 0, 0],
  //         "Carat 14K": [0, val, 0, 0],
  //         "Carat 18K": [0, 0, val, 0],
  //         "Carat 22K": [0, 0, 0, val],
  //       }[carat];

  //       goldPromises.push(
  //         $.ajax({
  //           type: "GET",
  //           crossDomain: true,
  //           url: gold,
  //           dataType: "json",
  //         }).then((json) => {
  //           const { total, breakdown: goldBreakdown } = calculateGold(
  //             json,
  //             ...goldValues
  //           );
  //           totalglvmo += total;
  //           breakdown = breakdown.concat(goldBreakdown);
  //         })
  //       );
  //     }

  //     if (metal === "PLATINUM") {
  //       platinumPromises.push(
  //         $.ajax({
  //           type: "GET",
  //           crossDomain: true,
  //           url: platinum,
  //           dataType: "json",
  //         }).then((json) => {
  //           const rate = json.rates.XPT;
  //           const value = (val * rate) / 28.35;
  //           totalptvmo += value;
  //           breakdown.push({
  //             type: "Platinum",
  //             grams: val,
  //             marketValue: value.toFixed(2),
  //             lylieCredit: (value * 1.25).toFixed(2),
  //           });
  //         })
  //       );
  //     }
  //   });

  //   Promise.all([...goldPromises, ...platinumPromises]).then(() => {
  //     const totalAmntMo = totalglvmo + totalptvmo;
  //     const intrst = (totalAmntMo * 7.5) / 100; //remove (totalAmntMo * 7.5) / 100
  //     const totalIntrst = totalAmntMo + intrst;
  //     const finalPrice = totalIntrst.toFixed(2);

  //     $(".mobile-total-amount input").val((totalAmntMo * 1.25).toFixed(2));

  //     // Generate and populate the table
  //     let tableHtml = "<table>";
  //     tableHtml +=
  //       "<tr><th>Metals</th><th>Grams</th><th>Market Value</th><th>Lylie Credit</th></tr>";

  //     breakdown.forEach((item) => {
  //       tableHtml += `<tr><td>${item.type}</td><td>${item.grams}g</td><td>£${item.marketValue}</td><td>£${item.lylieCredit}</td></tr>`;
  //     });

  //     tableHtml += `<tr><td colspan="1">TOTAL</td><td></td><td>£${totalAmntMo.toFixed(
  //       2
  //     )}</td><td>£${(totalAmntMo * 1.25).toFixed(2)}</td></tr>`;
  //     tableHtml += "</table>";

  //     // Replace loading spinner with the actual table
  //     $(".mobile-result-inner").html(tableHtml);
  //   });
  // });

  $(".mobile-calc-btn").on("click", function () {
    $(this).hide();
    $(".mobile-metal-options").hide();

    let totalglvmo = 0;
    let totalptvmo = 0;
    let breakdown = [];

    // Show loading spinner or placeholder
    $(".mobile-result-inner").html('<div class="loading-spinner">Loading...</div>');
    $(".mobile-metal-result, .ge-back-btn").show(); // Immediately show the tab
    $(".request_btn").show(); // Show the request button

    const goldPromises = [];
    const platinumPromises = [];

    $(".metal-detail").each(function () {
      const $this = $(this);
      const metal = $this.find(".mobile-metal").val();
      const val = parseFloat($this.find(".metal-gm").val());
      const carat = $this.find(".gold-metal-weight option:selected").attr("data-carat");

      // ---- GOLD CALCULATION ----
      if (metal === "GOLD") {
        const goldValues = {
          "Carat 9K": [val, 0, 0, 0],
          "Carat 14K": [0, val, 0, 0],
          "Carat 18K": [0, 0, val, 0],
          "Carat 22K": [0, 0, 0, val],
        }[carat];

        goldPromises.push(
          $.ajax({
            type: "GET",
            crossDomain: true,
            url: gold,
            dataType: "json",
          }).then((json) => {
            const { total, breakdown: goldBreakdown } = calculateGold(json, ...goldValues);
            totalglvmo += parseFloat(total);
            breakdown = breakdown.concat(goldBreakdown);
          })
        );
      }

      // ---- PLATINUM CALCULATION ----
      if (metal === "PLATINUM") {
        platinumPromises.push(
          $.ajax({
            type: "GET",
            crossDomain: true,
            url: platinum,
            dataType: "json",
          }).then((json) => {
            const rate = json.rates.XPT;
            // keep 4 decimal precision before rounding
            const value = ((val * rate) / 28.35).toFixed(4);
            totalptvmo += parseFloat(value);
            breakdown.push({
              type: "Platinum",
              grams: val,
              marketValue: parseFloat(value).toFixed(2),
              lylieCredit: parseFloat(value).toFixed(2), // same as market value
            });
          })
        );
      }
    });

    Promise.all([...goldPromises, ...platinumPromises]).then(() => {
      // ---- FINAL CALCULATION ----
      const totalAmntMo = totalglvmo + totalptvmo;
      const finalPrice = totalAmntMo.toFixed(2);

      // set total (same as market value)
      $(".mobile-total-amount input").val(finalPrice);

      // ---- GENERATE TABLE ----
      let tableHtml = "<table>";
      tableHtml += "<tr><th>Metals</th><th>Grams</th><th>Market Value</th><th>Lylie Credit</th></tr>";

      breakdown.forEach((item) => {
        const marketValue = parseFloat(item.marketValue).toFixed(2);
        const lylieCredit = parseFloat(item.lylieCredit).toFixed(2);

        tableHtml += `
          <tr>
            <td>${item.type}</td>
            <td>${item.grams}g</td>
            <td>£${marketValue}</td>
            <td>£${lylieCredit}</td>
          </tr>`;
      });

      tableHtml += `
        <tr>
          <td colspan="1">TOTAL</td>
          <td></td>
          <td>£${totalAmntMo.toFixed(2)}</td>
          <td>£${totalAmntMo.toFixed(2)}</td>
        </tr>`;
      tableHtml += "</table>";

      // Replace loading spinner with actual table
      $(".mobile-result-inner").html(tableHtml);
    });
  });



  $(".two-decimals").on("keypress", function (evt) {
    var $txtBox = $(this);
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46)
      return false;
    else {
      var len = $txtBox.val().length;
      var index = $txtBox.val().indexOf(".");
      if (index > 0 && charCode == 46) {
        return false;
      }
      if (index > 0) {
        var charAfterdot = len + 1 - index;
        if (charAfterdot > 3) {
          return false;
        }
      }
    }
    return $txtBox; //for chaining
  });
});

$(".engagement-ring").slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  lazyLoad: "ondemand",
  centerMode: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    },
  ],
});

// slider
$slick_slider = $(".mobile_slider");
settings_slider = {
  dots: true,
  lazyLoad: "ondemand",
  arrows: false,
  // more settings
};
slick_on_mobile($slick_slider, settings_slider);

// slick on mobile
function slick_on_mobile(slider, settings) {
  $(window).on("load resize", function () {
    if ($(window).width() > 868) {
      if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}
$(document).ready(function () {
  var docHeight = $("#book-con-popup").outerHeight();
  var enghowitWorkHeight = $(
    "#shopify-section-engagement-how-it-works"
  ).height();
  var engHeight = $("#engagement-image-with-text").height();
  var windowcustomerHeight = $(
    "#shopify-section-engagement-customer-says-slider"
  ).height();
  var windowfavHeight = $("#shopify-section-engagement-favorite").height();
  var totalHeight = +windowcustomerHeight + +windowfavHeight - 250;
  var totalengHeight = +enghowitWorkHeight + +engHeight - 250;
  $("#book-con-popup .modal").find(".popup-image img").css("height", docHeight);
  //$('#shopify-section-banner-engagement').find('.banner-image-div img').css("height", docHeight);
  // $('#engagement-image-with-text').find('.sticky-button').css("min-height", totalengHeight);
  $("#shopify-section-engagement-favorite")
    .find(".sticky-button")
    .css("min-height", totalHeight);
});
$(window).resize(function () {
  var windowHeight = $("#book-con-popup").outerHeight();
  var windowengHeight = $("#engagement-image-with-text").height();
  var windowenghowitWorkHeight = $(
    "#shopify-section-engagement-how-it-works"
  ).height();
  var windowcustomerHeight = $(
    "#shopify-section-engagement-customer-says-slider"
  ).height();
  var windowfavHeight = $("#shopify-section-engagement-favorite").height();
  var subtotalHeight = +windowcustomerHeight + +windowfavHeight - 250;
  var subtotalengHeight = +windowengHeight + +windowenghowitWorkHeight - 250;
  $("#book-con-popup").find(".popup-image img").css("height", windowHeight);
  //$('#shopify-section-banner-engagement').find('.banner-image-div img').css("height", windowHeight);
  // $('#engagement-image-with-text').find('.sticky-button').css("min-height", subtotalengHeight);
  $("#shopify-section-engagement-favorite")
    .find(".sticky-button")
    .css("min-height", subtotalHeight);
});

$(".comparison-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },
    {
      breakpoint: 868,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: false,
      },
    },
  ],
});
$(".csc-rpc-inner-mobile-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },
    {
      breakpoint: 868,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true,
      },
    },
  ],
});

$("a.crc-link").click(function () {
  $("html, body").animate(
    {
      scrollTop: $($(this).attr("href")).offset().top - 50,
    },
    500
  );
  return false;
});

$(".lab-btn").on("click", function () {
  $(this).toggleClass("active");
  $(this).parents(".lr-box").find(".lr-box-points").toggleClass("hide");
  $(".labgrown-diamond-detail-section").toggleClass("hide");
  $(".ethical-diamond-detail-section").addClass("hide");
  setTimeout(function () {
    if (!$(".labgrown-diamond-detail-section").hasClass("hide")) {
      $("html, body").scrollTop(
        $("#shopify-section-recycled-diamond-labgrown-detail").offset().top - 50
      );
    }
  }, 100);
});
$(".recyled-btn").on("click", function () {
  $(this).toggleClass("active");
  $(this).parents(".lr-box").find(".lr-box-points").toggleClass("hide");
  $(".ethical-diamond-detail-section").toggleClass("hide");
  $(".labgrown-diamond-detail-section").addClass("hide");
  setTimeout(function () {
    if (!$(".ethical-diamond-detail-section").hasClass("hide")) {
      $("html, body").scrollTop(
        $("#shopify-section-recycled-diamond-labgrown-detail").offset().top - 50
      );
    }
  }, 100);
});
$(".mobile-ethical-btn").on("click", function () {
  $(".mobile-ethical-diamond-section").toggleClass("hide");
});

setTimeout("$('.errors').fadeOut('slow')", 9000);

$(".colour-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  infinite: false,
  dots: false,
  asNavFor: ".alphabet-slider",
  arrows: false,
});

$(".alphabet-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  infinite: false,
  dots: false,
  asNavFor: ".colour-slider",
  arrows: false,
});

var $customerLogos = $(".customer-logos");
if ($customerLogos.length && $customerLogos.children().length) {
  $customerLogos.slick({
    slidesToShow: 5,
    slidesToScroll: 3,
    dots: false,
    infinite: true,
    autoplay: false,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
          {
        breakpoint: 420,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      }
    ],
  });
}

var $asSeenImage = $(".as_seen_image");
if ($asSeenImage.length && $asSeenImage.children().length) {
  $asSeenImage.slick({
    arrows: false,
    dots: false,
    infinite: true,
    initialSlide: 0,
    slidesToScroll: 1,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
}

$(document).ready(function () {
  $(".footer_btn").click(function () {
    $(".footer_tab").find(".panel").not($(this).next()).slideUp(300);
    $(".active").not(this).removeClass("active");

    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
  });

  $(".accordian_btn").click(function () {
    $(".cart_accordian").find(".accr_tab").not($(this).next()).slideUp(300);
    $(".active").not(this).removeClass("active");

    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
  });
});

$(".footer_arrow img").click(function () {
  $("html, body").animate({ scrollTop: 0 }, 600);
  return false;
});

$(document).ready(function () {
  // mobile

  $(".mobile_qty_selector select").on("change", function (e) {
    var selected_qty = $(this).find(":selected").val();
    console.log(selected_qty, "selected_qty");
    var currentVal = $(this).attr("data-id");
    console.log(currentVal, "currentVal");
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        quantity: selected_qty,
        id: currentVal,
      },
      success: function (cart) {
        location.reload(true);
      },
      error: function (response) {
        alert(response);
      },
    });
  });
});

$("select.langu_list").on("change", function () {
  $("#update_language").trigger("click");
});

$("li.search.desktop-search").click(function () {
  setTimeout(function () {
    $(".desk-search-drawer .input-group-field").focus();
  }, 100);
});

$(".select_packag label").click(function () {
  $(this).closest(".select_packag").find("label.active").removeClass("active");
  $(this).addClass("active");
});

$(".reduce_note_grid p").click(function () {
  $(".reduce_note_grid input").trigger("click");
});

// -deck
$(".deck_left_grid a").click(function () {
  $("#shopify-section-desck_banner").hide();
  $("#shopify-section-full_deck_banner").show();
});
$(".deck_right_grid a").click(function () {
  $("#shopify-section-desck_banner").hide();
  $("#shopify-section-condensed_deck_banner").show();
});
$(".con-deck-btn").click(function () {
  $("#shopify-section-desck_banner").hide();
  $("#shopify-section-condensed_deck_banner").hide();
  $("#shopify-section-full_deck_banner").show();
});

$(".eng-fill").hover(
  function () {
    $(this).parents(".full_deck_grid").addClass("result_hover");
  },
  function () {
    $(this).parents(".full_deck_grid").removeClass("result_hover");
  }
);

// == cart
$(".reduce_note_grid input").click(function () {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      console.log(cart, "cart");
      var subtotal_price = cart.total_price / 100;
      var total_price = subtotal_price.toFixed(2).replace(".00", "");
      console.log("total_price", total_price);
      var total_final = parseInt(total_price) + 1;
      $(".cart__subtotal .money").html("£" + total_final);
      if (cart.item_count === 0) {
        cartDrawerContent.innerHTML = "Cart is empty";
        //checkoutButton.classList.add('is-hidden');
      } else {
        renderCart(cart);
        // checkoutButton.classList.remove('is-hidden');
      }
    },
  });
});

// ==
$(".richtext_img_cnt").hover(
  function () {
    $(this).parents(".richtext_right_grid").addClass("result_hover");
  },
  function () {
    $(this).parents(".richtext_right_grid").removeClass("result_hover");
  }
);

// --select packag

$(document).ready(function () {
  $(".select_label").on("click", function () {
    $.post("/cart/update.js", {
      attributes: {
        Packaging: $(this).find("input").val(),
      },
    }).done(function () {
      console.log("Packaging updated......");
    });
  });
  $(".mobile_packag_grid select").on("change", function () {
    console.log("test area updated......");
    $.post("/cart/update.js", {
      attributes: {
        Packaging: $(this).find(":selected").val(),
      },
    }).done(function () {
      console.log("Packaging updated......");
    });
  });

  // ==
  $.post("/cart/update.js", {
    attributes: {
      Packaging: "Eco Wrap",
    },
  }).done(function () {
    console.log("Packaging updated......");
  });

  // ==mobile
  $.post("/cart/update.js", {
    attributes: {
      Packaging: "Eco Wrap",
    },
  }).done(function () {
    console.log("Packaging updated......");
  });
});

$(document).ready(function () {
  $(".enquire-drawer-btn, .enquire-drawer-close-btn").click(function () {
    var isOpening = !$(".enquire-drawer-right").hasClass("enquire-drawer-open");

    if (isOpening) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      $("html, body").css("overflow", "hidden");
    } else {
      $("html, body").css("overflow", "");
    }

    $(this).toggleClass("active");
    $("body").toggleClass("enquire-drawer-pushtoleft");
    $(".enquire-drawer-right").toggleClass("enquire-drawer-open");
  });

  $(".draw, .consultation-btn, .CONSULTATION_arr").click(function () {
    console.log('test are.........');
    $(this).toggleClass("active");
    $("body").toggleClass("enquire-drawer-pushtoleft");
    $(".enquire-drawer-consultation").toggleClass("enquire-drawer-open");
  });
});


$(".richtext-1").hover(function () {
  $(this)
    .parents(".richtext_right_grid")
    .find(".richtext_onhover p")
    .text(
      "Contains 92.5% pure silver and is termed 'sterling silver'. It is recognised by the hallmark '925' referencing 925 parts per 1,000 are silver."
    );
});

$(".richtext-2").hover(function () {
  $(this)
    .parents(".richtext_right_grid")
    .find(".richtext_onhover p")
    .text(
      "Contains 37.5% pure gold and the rest alloy. It is recognised by the hallmark '375' referencing 375 parts per 1,000 are gold."
    );
});

$(".richtext-3").hover(function () {
  $(this)
    .parents(".richtext_right_grid")
    .find(".richtext_onhover p")
    .text(
      "Contains 58.5% pure gold and the rest alloy. It is recognised by the hallmark '585' referencing 585 parts per 1,000 are gold."
    );
});

$(".richtext-4").hover(function () {
  $(this)
    .parents(".richtext_right_grid")
    .find(".richtext_onhover p")
    .text(
      "Contains 75% pure gold and the rest alloy. It is recognised by the hallmark '750' referencing 750 parts per 1,000 are gold."
    );
});

$(".richtext-5").hover(function () {
  $(this)
    .parents(".richtext_right_grid")
    .find(".richtext_onhover p")
    .text(
      "Contains 92% pure gold and the rest alloy. It is recognised by the hallmark '916' referencing 916 parts per 1,000 are gold."
    );
});

$(".richtext-6").hover(function () {
  $(this)
    .parents(".richtext_right_grid")
    .find(".richtext_onhover p")
    .text(
      "Contains 85% pure platinum and the rest alloy. It is recognised by the hallmark '850' referencing 850 parts per 1,000 are platinum."
    );
});

$(".richtext-7").hover(function () {
  $(this)
    .parents(".richtext_right_grid")
    .find(".richtext_onhover p")
    .text(
      "Contains 90% pure platinum and the rest alloy. It is recognised by the hallmark '900' referencing 900 parts per 1,000 are platinum."
    );
});

$(".richtext-8").hover(function () {
  $(this)
    .parents(".richtext_right_grid")
    .find(".richtext_onhover p")
    .text(
      "Contains 95% pure platinum and the rest alloy. It is recognised by the hallmark '950' referencing 950 parts per 1,000 are platinum."
    );
});

$(".e-wasteRecycling-banner .eng-btn").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".recycle-creadit-wrapper").offset().top,
    },
    1000
  );
});

$(document).ready(function () {
  function cartDelivery() {
    const now = new Date()
      .toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .toLowerCase();
    var splitTime = now.replace(" ", "");
    var gettime = $(".size-box-wrapper").attr("data-inv");
    $("#Custom_time").val(splitTime);
    console.log("gettime", gettime);
    if (gettime == "1") {
      $("#deliver_msg").val(
        "Orders before 1pm GMT ships same working day, after 1pm GMT ships next working day."
      );
    }
    if (gettime == "0") {
      $("#deliver_msg").val(
        "Handmade to order, please WhatsApp Us for exact shipping date."
      );
    }
  }
  cartDelivery();

  $("#metal-choice li a").on("click", function () {
    cartDelivery();
  });
  $(".single-option-selector").on("change", function () {
    cartDelivery();
  });
});

$(".video__overlay").on("click", function () {
  console.log("Playing video");

  // Ensure video element is visible and starts playing
  $(".iframe-vdo").css("z-index", "1"); // Assuming .iframe-vdo is a <video> element
  $(".desktop-index--video").get(0).play(); // Play the video
  $(".video__overlay").css("z-index", "0");
});

// Optional: Allow clicking on the video to restart or interact
$(".desktop-index--video").on("click", function () {
  const videoElement = $(this).get(0);

  if (videoElement.paused) {
    videoElement.play();
    $(".video__overlay").css("z-index", "0");
  } else {
    videoElement.pause();
    $(".video__overlay").css("z-index", "2");
  }
});

// ==gold exchange
$("#block_count-2 .eng-btn").click(function () {
  $("#block_count-2 .exchange_metal_desc_wrap").hide();
  $("#block_count-2 .exchange_metal_category_wrap").show();
});

$(".category_btn").click(function () {
  var MetalVlaue = $("#metal_one").val();
  var MetalVlaue1 = $("#metal_two.addMetal").val();
  var MetalVlaue2 = $("#metal_three.addMetal").val();

  $(".step_img_text.block_count-3").trigger("click");
  $(".step_img_text.block_count-3").addClass("current");
  $(".gold_step_grid-3").addClass("current");
});

$(".exchange-metal-input").keypress(function (e) {
  //if the letter is not digit then display error and don't type anything
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
    //display error message
    $(".category-error").html("Numbers Only").show().fadeOut(3000);
    $(".category-error").css("visibility", "visible").fadeOut(3000);
    return false;
  }
});

$("#block_count-1 .eng-btn").click(function () {
  var filter =
    /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  var email = $("#ContactFormEmail").val();
  var inputCode = $(".exchange-code-input").val();
  if (!filter.test(email)) {
    $("#block_count-1 .category-error").html("Please enter valid email.");
    $("#block_count-1 .category-error").css("display", "block");
    return false;
  } else if (inputCode == "") {
    $("#block_count-1 .category-error").html("Please enter code.");
  } else {
    $("#block_count-1 .category-error").hide();
    $(".step_img_text.block_count-2").trigger("click");
    $(".step_img_text.block_count-2").addClass("current");
    $(".gold_step_grid-2").addClass("current");
  }
});
$("#block_count-3 .eng-btn").click(function () {
  $(".step_img_text.block_count-4").trigger("click");
  $(".step_img_text.block_count-4").addClass("current");
  $(".gold_step_grid-4").addClass("current");
});
$("#block_count-4 .eng-btn").click(function () {
  $(".step_img_text.block_count-5").trigger("click");
  $(".step_img_text.block_count-5").addClass("current");
  $(".gold_step_grid-5").addClass("current");
});
$("#block_count-5 .eng-btn").click(function () {
  $(".Exchange_steps_wrapper").hide();
  $(".gold_exchange_banner.Thank_you_banner").show();
});
$(".start_excahnge_stap").click(function () {
  $(".gold_exchange_banner.start_excahnge_stap").hide();
  $(".Exchange_steps_wrapper").show();
});

$("#block_count-1 .exchange_back_arrow").click(function () {
  $(".Exchange_steps_wrapper").hide();
  $(".gold_exchange_banner.start_excahnge_stap").show();
});
$("#block_count-2 .exchange_metal_category_wrap .exchange_back_arrow").click(
  function () {
    $("#block_count-2 .exchange_metal_desc_wrap").show();
    $("#block_count-2 .exchange_metal_category_wrap").hide();
  }
);
$("#block_count-2 .exchange_metal_desc_wrap .exchange_back_arrow").click(
  function () {
    $(".step_img_text.block_count-1").trigger("click");
    $(".gold_step_grid-1").addClass("current");
  }
);
$("#block_count-3 .exchange_back_arrow").click(function () {
  $(".step_img_text.block_count-2").trigger("click");
  $(".gold_step_grid-2").addClass("current");
});
$("#block_count-4 .exchange_back_arrow").click(function () {
  $(".step_img_text.block_count-3").trigger("click");
  $(".gold_step_grid-3").addClass("current");
});
$("#block_count-5 .exchange_back_arrow").click(function () {
  $(".step_img_text.block_count-4").trigger("click");
  $(".gold_step_grid-4").addClass("current");
});
$(".Thank_you_banner .exchange_back_arrow").click(function () {
  $(".step_img_text.block_count-5").trigger("click");
  $(".Exchange_steps_wrapper").show();
  $(".gold_exchange_banner.Thank_you_banner").hide();
});

$(".opt-btn1").click(function () {
  $(".Category_info_wrapper1").show();
  $(".Category_info_wrapper1 #metal_two").addClass("addMetal");
  $(".opt-btn2").css("display", "flex");
  $(this).hide();
});
$(".opt-btn2").click(function () {
  $(".Category_info_wrapper2").show();
  $(".Category_info_wrapper2 #metal_three").addClass("addMetal");
  $(".opt-btn3").css("display", "flex");
  $(this).hide();
});
$(".opt-btn3").click(function () {
  $(".Category_info_wrapper3").show();
  $(".Category_info_wrapper3 #metal_four").addClass("addMetal");
  $(".opt-btn4").css("display", "flex");
  $(this).hide();
});
$(".opt-btn4").click(function () {
  $(".Category_info_wrapper4").show();
  $(".Category_info_wrapper4 #metal_five").addClass("addMetal");
  $(".opt-btn5").css("display", "flex");
  $(this).hide();
});
$(".opt-btn5").click(function () {
  $(".Category_info_wrapper5").show();
  $(".Category_info_wrapper5 #metal_six").addClass("addMetal");
  $(".opt-btn6").css("display", "flex");
  $(this).hide();
});
$(".opt-btn6").click(function () {
  $(".Category_info_wrapper6").show();
  $(".Category_info_wrapper6 #metal_seven").addClass("addMetal");
  $(".opt-btn7").css("display", "flex");
  $(this).hide();
});
$(".opt-btn7").click(function () {
  $(".Category_info_wrapper7").show();
  $(".Category_info_wrapper7 #metal_eight").addClass("addMetal");
  $(".opt-btn8").css("display", "flex");
  $(this).hide();
});
$(".opt-btn8").click(function () {
  $(".Category_info_wrapper8").show();
  $(".Category_info_wrapper8 #metal_nine").addClass("addMetal");
  $(".opt-btn9").css("display", "flex");
  $(this).hide();
});
$(".opt-btn9").click(function () {
  $(".Category_info_wrapper9").show();
  $(".Category_info_wrapper9 #metal_ten").addClass("addMetal");
  $(this).hide();
});

$(document).ready(function () {
  $(".step_img_text").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(".step_img_text").removeClass("current");
    $(".Exchange_steps").removeClass("current");
    $(".gold_step_grid").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
    $(this).parents(".gold_step_grid").addClass("current");
  });

  $(".step_img_text.block_count-6").click(function () {
    $(".gold_exchange_banner.Thank_you_banner").show();
    $(".Exchange_steps_wrapper").hide();
  });
});

$(".drop-down0 .selected a").click(function () {
  $(".drop-down0 .options ul").toggle();
});
$(".drop-down1 .selected a").click(function () {
  $(".drop-down1 .options ul").toggle();
});
$(".drop-down2 .selected a").click(function () {
  $(".drop-down2 .options ul").toggle();
});

//SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
$(".drop-down0 .options ul li a").click(function () {
  var text = $(this).html();
  $(".drop-down0 .selected a span").html(text);
  $(".drop-down0 .options ul").hide();
});
$(".drop-down1 .options ul li a").click(function () {
  var text = $(this).html();
  $(".drop-down1 .selected a span").html(text);
  $(".drop-down1 .options ul").hide();
});
$(".drop-down2 .options ul li a").click(function () {
  var text = $(this).html();
  $(".drop-down2 .selected a span").html(text);
  $(".drop-down2 .options ul").hide();
});

//HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
$(document).bind("click", function (e) {
  var $clicked = $(e.target);
  if (!$clicked.parents().hasClass("drop-down"))
    $(".drop-down .options ul").hide();
});

$("#submitButton").click(function (ev) {
  let text;
  // if (confirm("Are You confirm to send the mail!") == true) {
  var formData = {
    Customer_email: $("#ContactFormEmail").val(),
    code: $("#exchange-code-input").val(),
    Metal_category_1: $(".category_list .drop-down0 span").text(),
    Metal_One: $("#metal_one").val(),
    Metal_category_2: $(".category_list .drop-down1 span").text(),
    Metal_two: $("#metal_two").val(),
    Metal_category_3: $(".category_list .drop-down2 span").text(),
    Metal_three: $("#metal_three").val(),
    Metal_category_4: $(".category_list .drop-down2 span").text(),
    Metal_three: $("#metal_four").val(),
    Metal_category_5: $(".category_list .drop-down2 span").text(),
    Metal_three: $("#metal_five").val(),
    Metal_category_6: $(".category_list .drop-down2 span").text(),
    Metal_three: $("#metal_six").val(),
    Metal_category_7: $(".category_list .drop-down2 span").text(),
    Metal_three: $("#metal_seven").val(),
    Metal_category_8: $(".category_list .drop-down2 span").text(),
    Metal_three: $("#metal_eight").val(),
    Metal_category_9: $(".category_list .drop-down2 span").text(),
    Metal_three: $("#metal_nine").val(),
    Metal_category_10: $(".category_list .drop-down2 span").text(),
    Metal_three: $("#metal_ten").val(),
  };
  var output = "";
  for (var key in formData) {
    output +=
      '<div style="font-family: GT Walsheim Light;font-size: 16px;">' +
      key +
      ": " +
      formData[key] +
      "\n" +
      "</div>";
  }

  console.log(output);
  Email.send({
    Host: "smtp.elasticemail.com",
    Username: "enquiries@lylies.com",
    Password: "A730801B862C1E09D2F99034F7A7F7802694",
    To: "enquiries@lylies.com",
    From: "enquiries@lylies.com",
    Subject: "Gold Exchange Step",
    Body: "<div>" + output + "</div>",
  });
  $(".gold_exchange_banner.Thank_you_banner").show();
  //   } else {
  //     window.location='/pages/gold-exchange-step';
  // }
});
$(".close-modal-modal").on("click", function () {
  console.log("in");
  $(".blocker").css("opacity", "0");
  $(".blocker").css("z-index", "-1");
});

$(".e-wasteRecycling-banner .eng-btn").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".recycle-creadit-wrapper").offset().top,
    },
    1000
  );
});

$(document).ready(function () {
  function cartDelivery() {
    const now = new Date()
      .toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .toLowerCase();
    var splitTime = now.replace(" ", "");
    var gettime = $(".size-box-wrapper").attr("data-inv");
    $("#Custom_time").val(splitTime);
    console.log("gettime", gettime);
    if (gettime == "1") {
      $("#deliver_msg").val(
        "Order before 1pm GMT ships today. After 1pm GMT ships next working day."
      );
    }
    if (gettime == "0") {
      $("#deliver_msg").val(
        "Handmade to order, please WhatsApp Us for exact shipping date."
      );
    }
  }
  cartDelivery();

  $("#metal-choice li a").on("click", function () {
    cartDelivery();
  });
  $(".single-option-selector").on("change", function () {
    cartDelivery();
  });
});

$(".video__overlay").on("click", function () {
  console.log("videoURL");
  $(".iframe-vdo").css("z-index", "1");
  $(".desktop-index--video").trigger("play");
  $(".iframe-vdo").prop("muted", false);
});

$(document).ready(function () {
  $(window).on("resize", function (e) {
    checkScreenSize();
  });

  checkScreenSize();

  function checkScreenSize() {
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 768) {
      $(".exchange-right-grid").css(
        "height",
        $(window).innerHeight() - 227 + "px"
      );
      $(".gold_exchange_banner").css(
        "height",
        $(window).innerHeight() - 145 + "px"
      );
    }
  }

  setTimeout(function () {
    var GcountText = $(".reputon-reviews-count").text();
    var Gcount = parseInt(GcountText, 10); // 39
    $(".Googlecount").html(Gcount);
  }, 2000);

  setTimeout(function () {
    var GreviewText = $(".reputon-count-number").first().text();
    $(".review-count span").html(GreviewText);
  }, 2000);

  $(".Img_column_wrapper").click(function () {
    $(this).toggleClass("flip_card");
  });

  $(".flp_btn").mousemove(function () {
    $(this).css("background", "#FFF");
    $(this).css("border-color", "#FFF");
    $(this).css("color", "#778f72");
  });
  $(".flp_btn").mouseleave(function () {
    $(this).css("background", "transparent");
    $(this).css("border-color", "#fff");
    $(this).css("color", "#fff");
  });

  $(".flp_btn").click(function () {
    console.log("in");
    $(this).css("background", "transparent");
    $(this).css("border-color", "#fff");
    $(this).css("color", "#fff");
    // $(this).parents('.Img_column_wrapper').toggleClass('flip_card');
  });
});
